import React, {useCallback} from 'react';
import {useAsync} from '@bootcamp/shared/src/util/hooks';
import styled from 'styled-components';
import {useDocumentTitle} from '@bootcamp/shared/src/util/hooks';

import CheatSheets from '@bootcamp/web/src/bootcamps/pages/CheatSheets';

import AdultHealthImg from '@bootcamp/shared/src/assets/icons/nclex/AdultHealth.png'
import ChildHealthImg from '@bootcamp/shared/src/assets/icons/nclex/ChildHealth.png'
import CriticalCareImg from '@bootcamp/shared/src/assets/icons/nclex/CriticalCare.png'
import FundamentalsImg from '@bootcamp/shared/src/assets/icons/nclex/Fundamentals.png'
import MaternalandNewbornHealthImg from '@bootcamp/shared/src/assets/icons/nclex/MaternalandNewbornHealth.png'
import MentalHealthImg from '@bootcamp/shared/src/assets/icons/nclex/MentalHealth.png'
import PharmacologyImg from '@bootcamp/shared/src/assets/icons/nclex/Pharmacology.png'
import ManagementofCareImg from '@bootcamp/shared/src/assets/icons/nclex/ManagementofCare.png'

import firstBy from 'thenby';

const systemImgMap = {
  'Adult Health': AdultHealthImg,
  'Child Health': ChildHealthImg,
  'Critical Care': CriticalCareImg,
  'Fundamentals': FundamentalsImg,
  'Maternal & Newborn Health': MaternalandNewbornHealthImg,
  'Mental Health': MentalHealthImg,
  'Pharmacology': PharmacologyImg,
  'Management of Care': ManagementofCareImg,
};

const NCLEXCheatSheets = ({history}) => {
  const fetchCheatSheets = useCallback(async () => {
    const fetchResult = await fetch('https://dekni9rgkrcu0.cloudfront.net/json/nclex/cheatSheets.json', { cache: 'no-cache' });
    return fetchResult.json();
  }, []);

  let {value: items} = useAsync(fetchCheatSheets);

  if (!items) items = [];

  const formattedItems = items.map(({description, name, route, freeAccess}) => ({
    category: description,
    description,
    name,
    route,
    iconUrl: systemImgMap[description],
    freeAccess,
  }));

  const sortedItems = formattedItems.sort(firstBy('category').thenBy('name'));

  const categories = [...new Set(items.map(item => item.description))];

  return (
    <CheatSheets
      items={sortedItems}
      categories={categories}
      subTitle={'NCLEX Cheat Sheets'}
      body={"Everything you need to pass the NCLEX®, and nothing you don't. NCLEX Bootcamp's Cheat Sheets condense everything you need to know about a topic into a single, digestible resource."}
      title={'Classroom'}
      history={history}
      comingSoon
    />
  );
}

export default NCLEXCheatSheets;
